module.exports = __webpack_public_path__ + "static/media/security-icon-check.f1badcd9.svg";